module.exports = __webpack_public_path__ + "static/media/ceilings_lcs_60y_y.c5e6813c.csv";